import * as React from "react";
function SvgCamera(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.908 8H4v10h16V8h-4.658l-.597-.683L13.593 6h-2.935L9.505 7.317 8.908 8zm7.342-2l-1.451-1.659A1 1 0 0014.046 4h-3.842a1 1 0 00-.753.341L8 6H3a1 1 0 00-1 1v12a1 1 0 001 1h18a1 1 0 001-1V7a1 1 0 00-1-1h-4.75zM12 15a2 2 0 100-4 2 2 0 000 4zm0 2a4 4 0 100-8 4 4 0 000 8zm6-8a1 1 0 100 2 1 1 0 000-2z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgCamera);
export default ForwardRef;
